import React, { useState } from 'react';
import s from './Products.module.scss';
import Button from 'components/shared/Button';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetAllProducts from 'sdk/hooks/shop/useGetAllProducts';
import useAddProductToBasket from 'sdk/hooks/shop/useAddProductToBasket';
import { useNavigate, useParams } from 'react-router-dom';
import ProductCard from 'modules/shop/pages/ProductsByCategory/ProductCard';

interface ProductsProps {
    products?: any[];
}

const Products = ({ products: filteredProducts }: ProductsProps) => {
    const { id: salonId } = useParams();
    const { data: isAuthData } = useIsAuth();
    const userId = isAuthData?.user?.id;
    const { data: allProducts } = useGetAllProducts();
    const { mutate: addToBasket } = useAddProductToBasket();
    const navigate = useNavigate()

    const [loadingProductId, setLoadingProductId] = useState(null);

    const productsToDisplay = filteredProducts || allProducts;
    const salonProducts = productsToDisplay?.filter(product => String(product.salon) === salonId);

    const handleAddToBag = (product) => {
        if (!userId) {
            navigate('/sign-up');
            return;
        }

        setLoadingProductId(product.id);

        addToBasket(
            {
                createdBy: userId,
                productId: product.id,
                price: product?.price
            },
            {
                onSuccess: () => {
                    console.log('Product added successfully');
                },
                onError: (error) => {
                    console.error('Error adding to bag:', error);
                },
                onSettled: () => {
                    setLoadingProductId(null);
                },
            }
        );
    };

    return (
        <div className={s.products}>
            <div className={s.grid}>
                {salonProducts?.map((item) => (
                    <ProductCard
                        key={item.id}
                        product={item}
                        userId={userId}
                    />
                ))}
            </div>
        </div>
    );
};

export default Products;
